export default __webpack_public_path__ + "static/media/search-engine.ff003e40.png";